import React from 'react';
import { Link } from 'react-router-dom';
import { SITE, WEALTH_SERVICES, FINANCE_SERVICES, RISK_SERVICES } from '../data/siteData';
import './Footer.css';
import logo from '../assets/logof.png';
import buildingIcon from '../assets/amfi.png'
import apmi from '../assets/apmi.png'

const SOCIAL_LINKS = [
  {
    name: 'Instagram',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
    href: 'https://www.instagram.com/earn_money_create_wealth?utm_source=qr',
    color: '#E1306C',
  },
  {
    name: 'Facebook',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
    href: 'https://www.facebook.com/share/1Copqm8oWB/?mibextid=wwXIfr',
    color: '#1877F2',
  },
  {
    name: 'LinkedIn',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
    href: 'https://www.linkedin.com/in/narendragm03?utm_source=share_via&utm_content=profile&utm_medium=member_ios',
    color: '#0A66C2',
  },
  {
    name: 'WhatsApp',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
    href: 'https://wa.me/919849131273',
    color: '#25D366',
  },
  {
    name: 'YouTube',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.495 6.205a3.007 3.007 0 00-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 00.527 6.205a31.247 31.247 0 00-.522 5.805 31.247 31.247 0 00.522 5.783 3.007 3.007 0 002.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 002.088-2.088 31.247 31.247 0 00.5-5.783 31.247 31.247 0 00-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/>
      </svg>
    ),
    href: 'https://youtube.com/@earnmoneycreatewealth03?si=Qdxq7askgZT2M5BF',
    color: '#FF0000',
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      {/* <div className="footer-cta-strip">
        <div className="footer-cta-inner">
          <div>
            <div className="footer-cta-label">Ready to grow your wealth?</div>
            <div className="footer-cta-title">Start with a Free Consultation</div>
          </div>
          <div className="footer-cta-actions">
            <a href={`tel:${SITE.contact.phone}`} className="footer-cta-btn cta-whatsapp">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/></svg>
              Call Now
            </a>
            <a href={`https://wa.me/91${SITE.contact.phone}`} target="_blank" rel="noopener noreferrer" className="footer-cta-btn cta-whatsapp">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              WhatsApp
            </a>
            <a href={`mailto:${SITE.contact.email}`} className="footer-cta-btn cta-whatsapp">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
              Email Us
            </a>
          </div>
        </div>
      </div> */}

      <div className="footer-main">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src={logo} alt="LMS Marketing & Services" className="footer-logo-image" />
            </div>
            <p className="footer-desc">
              {SITE.tagline}. Your trusted financial partner in Hyderabad for wealth management, insurance, and loan solutions.
            </p>
            <div className="footer-contact-items">
              <a href={`tel:${SITE.contact.phone}`} className="footer-contact-item">
                <span>📞</span> {SITE.contact.phone}
              </a>
              <a href={`mailto:${SITE.contact.email}`} className="footer-contact-item">
                <span>✉</span> {SITE.contact.email}
              </a>
              <div className="footer-contact-item">
                <span>📍</span>
                <span>{SITE.contact.address}</span>
              </div>
            </div>
          </div>

          {/* Wealth Services */}
          <div className="footer-col">
            <h4 className="footer-col-title">Wealth Management</h4>
            <ul>
              {WEALTH_SERVICES.map(s => (
                <li key={s.id}>
                  <Link to={`/service/wealth/${s.id}`} className="footer-link">{s.short}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Risk + Finance Services */}
          <div className="footer-col">
            <h4 className="footer-col-title">Risk Management</h4>
            <ul>
              {RISK_SERVICES.map(s => (
                <li key={s.id}>
                  <Link to={`/service/risk/${s.id}`} className="footer-link">{s.name}</Link>
                </li>
              ))}
            </ul>
            <h4 className="footer-col-title" style={{ marginTop: 24 }}>Finance Management</h4>
            <ul>
              {FINANCE_SERVICES.map(s => (
                <li key={s.id}>
                  <Link to={`/service/finance/${s.id}`} className="footer-link">{s.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links + Social */}
          <div className="footer-col">
            <h4 className="footer-col-title">Quick Links</h4>
            <ul>
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/wealth-management" className="footer-link">Wealth Management</Link></li>
              <li><Link to="/risk-management" className="footer-link">Risk Management</Link></li>
              <li><Link to="/finance-management" className="footer-link">Finance Management</Link></li>
              <li><Link to="/blogs" className="footer-link">Blog</Link></li>
              <li><Link to="/gallery" className="footer-link">Gallery</Link></li>
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
            </ul>
            <h4 className="footer-col-title" style={{ marginTop: 24 }}>Follow Us</h4>
            <div className="footer-social">
              {SOCIAL_LINKS.map(s => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-btn"
                  title={s.name}
                  style={{ '--social-color': s.color }}>
                  {s.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Registrations Section */}
        <div className="footer-registrations">
<div className="footer-registrations-inner">
  <div className="footer-reg-item">
    <div className="footer-reg-icon-wrapper">
      <img 
        src={buildingIcon} 
        alt="AMFI Registered" 
        className="footer-reg-badge-img"
      />
    </div>
    <div>
      <div className="footer-reg-label">AMFI Registered</div>
      <div className="footer-reg-value">Mutual Fund Distributor (ARN-118614)</div>
    </div>
  </div>
  <div className="footer-reg-divider"></div>
  <div className="footer-reg-item">
    <div className="footer-reg-icon-wrapper emoji">
      <img 
        src={apmi} 
        alt="AMFI Registered" 
        className="footer-reg-badge-img"
      />
    </div>
    <div>
      <div className="footer-reg-label">APMI Registered</div>
      <div className="footer-reg-value">PMS Distributor (APRN06206)</div>
    </div>
  </div>
</div>
        </div>

        <div className="footer-legal">
          <Link to="/terms-conditions" className="footer-legal-link">Terms &amp; Conditions</Link>
          <span className="footer-legal-sep">|</span>
          <Link to="/privacy-policy" className="footer-legal-link">Privacy Policy</Link>
          <span className="footer-legal-sep">|</span>
          <a rel="noopener noreferrer" className="footer-legal-link">AMFI Registered</a>
          <span className="footer-legal-sep">|</span>
          <a rel="noopener noreferrer" className="footer-legal-link">APMI Registered</a>
        </div>
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            © {new Date().getFullYear()} LMS Marketing &amp; Services. All rights reserved.
          </div>
          <div className="footer-bottom-right">
            Secunderabad, Telangana — India | SEBI Registered Advisory
          </div>
        </div>
      </div>
    </footer>
  );
}